<div fxLayout="column" fxLayoutAlign="space-between">
  <div fxFlex>
    <h3>Create a new email route</h3>
    <p>Please enter the email address you want to create a route for</p>
  </div>

  <div fxLayout fxLayoutAlign="start start" fxLayoutGap="12px">
    <mat-form-field fxFlex>
      <input matInput [(ngModel)]="alias" />
    </mat-form-field>
    <span class="domain__text">&#64;host.hospitable.com</span>
  </div>

  <div fxLayoutAlign="end center" fxLayoutGap="8px" style="margin-top: 40px">
    <button type="submit" mat-flat-button class="button__secondary" (click)="cancelClicked()">Cancel</button>
    <button type="submit" mat-flat-button (click)="okClicked()">Create</button>
  </div>
</div>
